import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import '../../styling/dialog.css'
import { strings } from "../../strings"


const DeleteEventDialog = ({ open, closeConfirm, closeCancel }) => {

    let w = window.innerWidth
    let h = window.innerHeight

    return (
        <Dialog className="confirmation-dialog" open={open}>
            <DialogTitle style={{ width: `${w > h ? '30vw' : '65vw'}` }}>{strings.dialogs.deleteTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {strings.dialogs.deleteConfirm}
                </DialogContentText>
            </DialogContent>
            <DialogActions className="dialog-actions">
                <span className="cancel-dialog" onClick={closeCancel} style={{ cursor: "pointer" }}>
                    {strings.dialogs.cancel}
                </span>
                <span className="confirm-dialog" onClick={closeConfirm} style={{ cursor: "pointer" }}>
                    {strings.dialogs.deleteTitle}
                </span>
            </DialogActions>
        </Dialog>
    )

}

export default DeleteEventDialog